export default "__VITE_ASSET__Cv6HYtc5__"